const isLocalhost = window.location.hostname === 'front.localhost.com'
    , settings = {
      REACT_APP_API_URL: isLocalhost ? 'http://todoe.localhost.com' : 'https://todo.inverser.pro',
      REACT_APP_APP_NAME: 'Многозадачник',
      REACT_APP_API_URL_IMG: isLocalhost ? 'http://todoe.localhost.com/public/avatars/' : 'https://todo.inverser.pro/public/avatars/',
    }
  ;

export default settings;